export default "__VITE_ASSET__09f5be54__"